<div class="modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">Import users error</div>
    </h2>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal invalid-eol-scenario-container">
    <div class="error-container">
      <!-- Error Details Header -->
      <div class="error-header">Error Details</div>

      <!-- Error Message -->
      <div class="error-section" *ngIf="getErrorMessage()">
        <label class="error-label">Error:</label>
        <span class="error-value">{{ getErrorMessage() }}</span>
      </div>

      <!-- Duplicate Emails -->
      <div class="error-section" *ngIf="getDuplicateEmails().length > 0">
        <label class="error-label">Duplicate Emails Found:</label>
        <div class="email-list">
          <span *ngFor="let email of getDuplicateEmails()" class="email-item">
            {{ email }}
          </span>
        </div>
      </div>

      <!-- File Name -->
      <div class="error-section" *ngIf="errorData?.fileName">
        <label class="error-label">File:</label>
        <span class="error-value">{{ errorData.fileName }}</span>
      </div>

      <!-- No Data Available -->
      <div class="error-section" *ngIf="!getErrorMessage() && getDuplicateEmails().length === 0">
        <span class="no-data">No error details available</span>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="cancelBtn" (click)="onClose()">Close</button>
  </div>
</div>
